import { createContext } from "react"
import { Injector } from "../../modules/di/Injector"

export const InjectorContext = createContext<Injector>(null as unknown as Injector)
